import { MINUTE, type SourceDefinition } from '../types';

export const config = {
  id: 'flights',
  kind: 'route',
  url: '/api/flights',
  refetchMiliseconds: 20_000,
  staleAfterMiliseconds: 4 * MINUTE,
  preload: 'fetch',
} satisfies SourceDefinition;
